import D2C_InstanceAWS from './AWS'
import D2C_InstanceAzure from './Azure'
import D2C_InstanceCustom from './Custom'
import D2C_InstanceDO from './DO'
import D2C_InstanceGCP from './GCP'
import D2C_InstanceUpcloud from './Upcloud'
import D2C_InstanceVultr from './Vultr'

export default {
  InstanceAWS: D2C_InstanceAWS,
  InstanceAzure: D2C_InstanceAzure,
  InstanceCustom: D2C_InstanceCustom,
  InstanceDO: D2C_InstanceDO,
  InstanceGCP: D2C_InstanceGCP,
  InstanceUpcloud: D2C_InstanceUpcloud,
  InstanceVultr: D2C_InstanceVultr,
}
